import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "ui/hook/store";
import { selectIsAuthenticationLoading } from "domain/auth/auth.selectors";
import { useForm } from "react-hook-form";
import { Inputs } from "ui/pages/inputsType";
import { registerUser } from "domain/auth/auth.actions";
import { translate } from "ui/i18n";
import { INInput } from "ui/pages/app/components/inputs/INInput";
import { Trans } from "react-i18next";
import { PrimaryButton } from "ui/pages/app/components/buttons/PrimaryButton";
import { i18nKey } from "domain/entities/activities.entities";

export function Register() {
  const location = useLocation();
  const navigate = useNavigate();
  const email = location.state?.email;
  const dispatch = useAppDispatch();
  const isLoading = useAppSelector(selectIsAuthenticationLoading);
  const { register, handleSubmit, formState } = useForm<Inputs>({
    mode: "onSubmit",
    defaultValues: {
      password: "",
    },
  });

  useEffect(() => {
    if (!email) navigate("/auth");
  }, [email]); //eslint-disable-line

  const { errors, isDirty } = formState;

  const handleFormSubmit = async (data: Inputs) => {
    const result = await dispatch(
      registerUser({ email, password: data.password })
    ).unwrap();
    if (result.success) {
      navigate("/account-type", { state: { email } });
    }
  };

  const validatePassword = (v: string) => {
    return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z\d\s:]).{8,}$/.test(v);
  };

  return (
    <div className="flex flex-col items-center">
      <h2 className="text-center">
        {translate("ns1:Register.CreateYourPassword")}
      </h2>

      <div className="w-full max-w-[430px]">
        <form
          onSubmit={handleSubmit(handleFormSubmit)}
          className="mb-4 mt-6 md:mb-8 md:mt-12"
        >
          <INInput
            type="password"
            error={errors.password}
            label={translate("ns1:Input.Labels.Password")}
            placeholder={translate("ns1:Input.Labels.Password")}
            register={{
              ...register("password", {
                required: translate("ns1:Input.Errors.Required"),
                validate: {
                  passwordFormat: (v) => validatePassword(v),
                },
              }),
            }}
          />
          <div
            className={`mb-4 mt-4 text-xs leading-5 text-darkGrey-600 md:mb-8 md:mt-6 ${
              errors.password ? "text-error" : ""
            }`}
          >
            <Trans
              i18nKey={"Input.Errors.PasswordFormat" as i18nKey}
              components={[<span className="font-extrabold" />]}
            />
          </div>

          <PrimaryButton
            type="submit"
            disabled={!isDirty || isLoading}
            width="100%"
            height="52px"
            onClick={handleSubmit(handleFormSubmit)}
          >
            {translate("ns1:Auth.Continue")}
          </PrimaryButton>
        </form>
      </div>
    </div>
  );
}
